interface DebouncedFunction {
  (...args: any[]): void;
  // Drops a pending call, so a caller that is going away - an unmounting
  // component - does not fire after its own lifetime
  cancel: () => void;
}

const debounce = (func: Function, wait: number): DebouncedFunction => {
  let timeout: NodeJS.Timeout;

  const executedFunction = (...args: any[]) => {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };

  executedFunction.cancel = () => clearTimeout(timeout);

  return executedFunction;
};

export default debounce;
